import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const BubbleSquareFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.501201 6.63771L0.501219 6.63528C0.506796 5.87909 0.532121 5.21415 0.589575 4.62975C0.939244 1.07306 2.47899 0.5 8 0.5C14.5625 0.5 15.5 1.30966 15.5 6.97727C15.5 12.6449 14.5625 13.4545 8 13.4545C6.68446 13.4545 5.59497 13.422 4.69375 13.3243L0.5 15.5V6.63636L0.501201 6.63771ZM11.3332 6.3001H4.6665V4.9001H11.3332V6.3001ZM4.6665 7.56676H9.99984V8.96676H4.6665V7.56676Z", fill: "var(--magritte-ui-icon-color)" }) }) }) }));
const BubbleSquareFilledSize16 = hoc(forwardRef(BubbleSquareFilledSize16Component), 'BubbleSquareFilledSize16');

export { BubbleSquareFilledSize16 as default };
//# sourceMappingURL=BubbleSquareFilledSize16.js.map
